import { CardPaymentMethodData, FoodCardData } from "@payment-ui/interfaces/Card";
import { isSodexoCard } from "./Card";
import { MAX_CVV_LENGTH } from "@payment-ui/constants/Card";

// helpers
import { getValidCardCvvLength } from "@payment-ui/helpers/Card";

export const isCVVMandatory = (methodData: CardPaymentMethodData): boolean => {
    return methodData.meta.cvvMandatory ?? false;
};

export const getCvvRequired = (
    methodData: CardPaymentMethodData,
    cardData: FoodCardData,
): boolean => {
    if (isSodexoCard(methodData.meta) || !isCVVMandatory(methodData)) return false;
    return cardData.cvvRequired;
};

export const getCvvMessage = (methodData: CardPaymentMethodData): string => {
    return methodData.meta.cvvMessage ?? "";
};

export const validateCVV = (methodData: CardPaymentMethodData, cvv: string, cvvRequired: boolean): boolean => {
    if (!cvvRequired) {
        return true;
    }

    // for amex: 4, default: 3
    const MIN_CVV_LENGTH = getValidCardCvvLength(methodData);

    return isCVVMandatory(methodData)
        ? cvv.length >= MIN_CVV_LENGTH && cvv.length <= MAX_CVV_LENGTH
        : cvv.length === 0 || cvv.length <= MAX_CVV_LENGTH;
};
